import { Controller } from '@hotwired/stimulus'
import hotkeys from 'hotkeys-js'

export class HotkeysController extends Controller<HTMLElement> {
  static values = {
    keys: String,
  }

  declare keysValue: string

  connect(): void {
    hotkeys(this.keysValue, this.triggerClick)
  }

  disconnect(): void {
    hotkeys.unbind(this.keysValue)
  }

  private triggerClick = (_event: KeyboardEvent) => {
    this.element.click()
  }
}
